import { render, staticRenderFns } from "./SecureElementComponent.vue?vue&type=template&id=3f98e6d0&scoped=true&"
import script from "./SecureElementComponent.vue?vue&type=script&lang=ts&"
export * from "./SecureElementComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f98e6d0",
  null
  
)

export default component.exports